import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CheckBoxOutlineBlankIcon(props: IconProps) {
    return <Icon {...props} iconKey={"check_box_outline_blank"}/>
}
